<template>
  <div>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      :overlay="false"
      fullscreen
      width="700"
      @keydown.esc="closeDialog"
    >
      <v-card>
        <v-toolbar
          style="
          position: -webkit-sticky;
          position: sticky; top: 0px"
          dark
          color="yellow darken-4"
        >
          <v-toolbar-title class="pl-3">{{title}}</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-tooltip bottom>
            <v-btn
              icon
              :loading="loading"
              :disabled="disableSave || !fileinput"
              @click="saveDialog"
              class="mr-3"
              slot="activator"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <span>Save</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn icon @click.native="closeDialog()" class="mr-3" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>

        <v-card-text>
          <v-container fill-height v-if="dialogLoading">
            <v-layout align-center justify-center>
              <v-progress-circular :size="40" :width="3" color="primary" indeterminate></v-progress-circular>
            </v-layout>
          </v-container>
          <v-container v-else>
            <div>
              <v-layout class="mt-5" align-center justify-center>
                <h2 class="text-xs-center">Select a .csv file</h2>
              </v-layout>
              <v-layout align-center justify-center>
                <input
                  class="text-xs-center ml-5 pt-3"
                  ref="inputUpload"
                  type="file"
                  @change="onFileChange"
                  accept=".csv"
                >
              </v-layout>
              <v-layout align-center justify-center>
                <v-btn
                  color="yellow darken-4"
                  class="elevation-6"
                  large
                  fab
                  dark
                  @click="uploadFile"
                >
                  <v-icon>file_upload</v-icon>
                </v-btn>
              </v-layout>
              <v-layout align-center justify-center>
                <slot></slot>
              </v-layout>
            </div>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    dialog: Boolean,
    confirmDialog: Boolean,
    loading: Boolean,
    dialogLoading: Boolean,
    disableSave: Boolean
  },
  data() {
    return {
      downloadCsv: false,
      fileinput: ""
    };
  },
  computed: {},
  methods: {
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (files[0] === undefined) {
        this.fileinput = "";
      }
      if (!files.length) return;
      this.createInput(files[0]);
    },
    createInput(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = e => {
        vm.fileinput = reader.result;
      };
      reader.readAsText(file);
    },
    uploadFile() {
      this.$emit("selectFile", this.fileinput);
    },
    saveDialog() {
      this.$emit("saveDialog");
    },
    openDialog() {
      this.$emit("openDialog");
    },
    closeDialog() {
      this.$emit("closeDialog");
      //   this.$clearTempData();
    }
  }
};
</script>

<style>
</style>
